function parseUTCToLocal(dateStr) {
    // Check if it already ends with Z (i.e., it's UTC)
    let isoStr = dateStr;
    // Replace space with 'T' if needed
    if (!dateStr.includes('T')) {
        isoStr = dateStr.replace(' ', 'T');
    }
    // Add 'Z' if not present
    if (!isoStr.endsWith('Z')) {
        isoStr += 'Z';
    }
    return new Date(isoStr);
}
export const formatLocalDateTime = (utcTimestamp) => {
    const localDate = parseUTCToLocal(utcTimestamp);
    const date = new Date(localDate);
    const localTimeString = date.toLocaleString();
    return new Intl.DateTimeFormat(undefined, {
        dateStyle: 'short',
        timeStyle: 'short',
    }).format(new Date(localTimeString)); // Defaults to the local timezone
};
